import * as React from 'react'
import { InputSelect } from '../../atoms/input-select/input-select'
import { Button } from '../../atoms/button/button'
import CollegeIcon from '../../../assets/images/form/college-icon.svg'
import { Context } from '../../../context/app-context'
import CollegeService from '../../../services/college-service'
import useCountry from '../../../shared/hooks/useCountry'
import { concourseId } from '../../../constants/activity-constants'
import { useForm } from 'react-hook-form'
import './form-register-college.scss'

export const FormRegisterCollege = ({ setFormStep }) => {
  const { userInfo, dispatch } = React.useContext(Context)
  const [isLoading, setIsLoading] = React.useState(false)
  const [selectedCollege, setSelectedCollege] = React.useState()
  const [collegeList, setCollegeList] = React.useState()
  const [citiesFiltered, setCitiesFiltered] = React.useState(null)
  const COUNTRY_CONTACT = process.env.COUNTRY_CONTACT || '0180011111'
  const {
    actualCitiesList,
    actualDeparmentList,
    filterCitiesByDeparment,
    mapDeparmentOptions,
    mapCitiesOptions,
  } = useCountry()

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
    getValues
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      countryState: userInfo?.location?.countryStateName || '',
      city: userInfo?.location?.cityName || '',
    },
  })

  const setGeneralError = React.useCallback(
    (error = 'Ha ocurrido una exepción inesperada') => {
      setError('college', {
        type: 'customError',
        message: error,
      })
    },
    [setError]
  )

  const handleChangeDepartment = option => {
    let newCities = filterCitiesByDeparment(option.value)
    setCitiesFiltered(newCities)
    setValue('city', '')
    setValue('college', '')
    setCollegeList([])
  }

  const mapCollegeList = colleges => {
    let res =
      colleges.map(option => ({
        value: option.schoolId || option.value,
        name: option.nameSchool || option.name,
      })) || []
    return res
  }

  const handleChangeCity = React.useCallback(
    city => {
      clearErrors('college')

      CollegeService.getCollegeByCity({
        cityId: city?.value,
      })
        .then(response => {
          if (response.status === 200) {
            setCollegeList(mapCollegeList(response.data))
          } else {
            setGeneralError(response?.userMessage)
            setCollegeList([])
          }
        })
        .catch(() => {
          setGeneralError()
          setCollegeList([])
        })
        .finally(() => {
          setValue('college', '')
        })
    },
    [setGeneralError, setValue, clearErrors]
  )

  const handleChangeCollege = ({ value }) => {
    setSelectedCollege(value)
  }

  const handleBack = () => {
    setFormStep(2)
  }

  const getUserParticipation = React.useCallback(() => {
    CollegeService.getUserParticipation({ concourseId }).then(response => {
      if (response.status === 200) {
        dispatch({
          type: 'set',
          payload: { userParticipation: response.data },
        })
      }
    })
  }, [dispatch])
  
  const onSubmit = () => {
    if (isLoading || !selectedCollege) return
    setIsLoading(true)

    const payload = {
      description: selectedCollege,
      competitionId: concourseId,
    }

    CollegeService.saveParticipation(payload)
      .then(response => {
        if (response.status === 200 || response.errorCode === 'DEM282') {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'Interacciones - Colegio Registrado',
            category: 'cole challenge',
            action: 'click',
            label: 'registrar mi colegio',
            Departamento: getValues('countryState'),
            Ciudad: getValues('city'),
            Colegio: getValues('college'),
          })
          getUserParticipation()
          setFormStep(2)
        } else {
          setGeneralError(response.userMessage)
        }
      })
      .catch(() => {
        setGeneralError()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  React.useEffect(() => {
    if (userInfo?.location && userInfo?.location?.city) {
      let defaultContryState = userInfo?.location.countryState
      let newCities = filterCitiesByDeparment(defaultContryState)
      setCitiesFiltered(newCities)
      handleChangeCity({ value: userInfo?.location?.city })
    }
  }, [userInfo, handleChangeCity])

  return (
    <div className="f-register-college">
      <div className="f-register-college__header">
        <img
          src={CollegeIcon}
          alt="icono colegios"
          className="f-register-college__header__icon"
        />

        <h3 className="f-register-college__header__title">
          TERMINA EL REGISTRO <br /> DE TU COLEGIO
        </h3>

        <div className="f-register-college__header__description">
          <p>
            Así las claves que registres ahora contarán tanto para tu
            participación individual como para tu colegio registrado
          </p>
        </div>
      </div>
      <form
        className="f-register-college__body"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Button
          color="white"
          type="button"
          onClick={handleBack}
          text={
            <>
              <i className="far fa-angle-left" /> Regresar
            </>
          }
          className="f-register-college__body__back-button"
        />

        <div className="f-register-college__body__fields">
          <InputSelect
            name="countryState"
            register={register}
            errors={errors}
            setValue={setValue}
            validations={{ required: 'Este campo es requerido' }}
            label="DEPARTAMENTO"
            options={mapDeparmentOptions(actualDeparmentList)}
            onChange={handleChangeDepartment}
          />
          <InputSelect
            name="city"
            register={register}
            errors={errors}
            setValue={setValue}
            validations={{ required: 'Este campo es requerido' }}
            label="CIUDAD"
            options={mapCitiesOptions(citiesFiltered || actualCitiesList)}
            onChange={handleChangeCity}
          />
          <InputSelect
            name="college"
            register={register}
            errors={errors}
            setValue={setValue}
            validations={{ required: 'Este campo es requerido' }}
            label="TU COLEGIO"
            placeholder="Selecciona un colegio"
            className="f-register-college__body__fields__field--full-width"
            options={collegeList}
            onChange={handleChangeCollege}
          />
        </div>

        <div className="f-register-college__body__no-college">
          Si no encontraste tu colegio y quieres registrarlo, comunícate con
          Nosotras a través de nuestro{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://api.whatsapp.com/send?phone=573233216593&text=%C2%A1Hola!%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F%20%0A%0AEn%20este%20chat%20te%20ayudaremos%20a%20responder%20las%20preguntas%20sobre%20la%20marca%20Nosotras%20y%20NosotrasOnline.%20Si%20tienes%20una%20consulta%20para%20nuestra%20ginec%C3%B3loga%20o%20psic%C3%B3loga%20hazla%20aqu%C3%AD%20https%3A%2F%2Fwww.nosotrasonline.com.co%2Fentre-nosotras%2Fconsultorios%2F%0A%0AHorario%20de%20atenci%C3%B3n%20de%20lunes%20a%20viernes%20de%208am%20a%206pm."
          >
            WhatsApp
          </a>{' '}
          o línea de Atención <b>{COUNTRY_CONTACT}</b>
        </div>

        <Button
          color="pink"
          type="submit"
          text="REGISTRA TU COLEGIO"
          className="f-register-college__body__button"
          isLoading={isLoading}
        />
      </form>
    </div>
  )
}
